export default __webpack_public_path__ + "images/94bf350fab85c706eb6c36e78c44ab95-snow_sports_small.webp";